import DataRemover from "modus/components/misc/DataRemover";
import React, {  } from "react";
import { Box } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { useHistory } from "react-router";
import { useAsyncAction } from "legacy-components/form/action/AsyncAction";
import ApiService, { IdentityApplication } from "../../services/ApiService";


interface ApplicationRemoverProps {
    application: IdentityApplication;
    consumerKey?: string;
    iconOnly?: boolean;
    onSuccess?: ()=>void;
}

export const ApplicationRemover: React.FC<ApplicationRemoverProps> = ({ application, iconOnly=false, consumerKey, onSuccess }) => {
    const history = useHistory();
    const [deleteState, {subscribe} ] = useAsyncAction(() =>
        ApiService.delete(
         application.consumerKey ?? consumerKey
        )
      );

return (
<DataRemover
            style={{ backgroundColor:   "#DA212C", color: "#FFFFFF", border: 'none'}}
            confirmationText={application?.applicationName}
            enterButtonText={iconOnly ? undefined : "Delete Application"}
            onConfirm={subscribe}
            asyncActionState={deleteState}
            tooltipText={"This will delete the application permanently."}
            title="Delete Application"
            successMessage="Deleted Successfully"
            onSuccess={()=>{
                if (onSuccess) {
                    onSuccess();
                } else {
                    history.push("/home/apis/list");
                }
            }}
            icon={iconOnly?undefined: <span />}
            message={
                <Box>
                    <Alert severity="error">Deleting an application will break any current integrations using this application.</Alert>
                    <Box marginTop={"30px"}>
                    This action cannot be undone. This will permanently remove the application "{application?.applicationName}" and cannot be accessed elsewhere.
                    <br/>
                    </Box>
                </Box>
            }
            />
        );
    }